"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEInvoice = void 0;
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
/** SA VAT numbers are 10 digits beginning with 4. */
const SA_VAT = /^4\d{9}$/;
function round2(n) {
    return Math.round((n + Number.EPSILON) * 100) / 100;
}
/**
 * Validate against South African tax-invoice rules (VAT Act s20) and internal
 * arithmetic consistency. Structural, syntax-independent — it will still hold
 * once the SARS CIUS is layered on top.
 */
function validateEInvoice(inv) {
    var _a, _b, _c, _d, _e, _f, _g;
    const errors = [];
    const warnings = [];
    if (!inv.id)
        errors.push('Missing invoice number (BT-1).');
    if (!ISO_DATE.test(inv.issueDate)) {
        errors.push('Issue date (BT-2) must be ISO yyyy-mm-dd.');
    }
    if (!inv.currency)
        errors.push('Missing currency (BT-5).');
    // Seller — a tax invoice must identify the VAT-registered supplier.
    if (!((_a = inv.seller) === null || _a === void 0 ? void 0 : _a.name))
        errors.push('Missing seller name (BT-27).');
    if (!((_b = inv.seller) === null || _b === void 0 ? void 0 : _b.vatNumber)) {
        errors.push('Missing seller VAT number (BT-31) — required on a tax invoice.');
    }
    else if (!SA_VAT.test(inv.seller.vatNumber)) {
        warnings.push(`Seller VAT number '${inv.seller.vatNumber}' is not a valid SA VAT format (4 followed by 9 digits).`);
    }
    if (!((_c = inv.lines) === null || _c === void 0 ? void 0 : _c.length))
        errors.push('Invoice has no lines.');
    (_d = inv.lines) === null || _d === void 0 ? void 0 : _d.forEach((l, i) => {
        if (!l.description)
            errors.push(`Line ${i + 1}: missing description.`);
        if (!(l.quantity > 0))
            errors.push(`Line ${i + 1}: quantity must be > 0.`);
        if (l.vatCategory === 'S' && !(l.vatRate > 0)) {
            errors.push(`Line ${i + 1}: standard-rated (S) line must have a rate > 0.`);
        }
        if ((l.vatCategory === 'Z' || l.vatCategory === 'E' || l.vatCategory === 'O') && l.vatRate !== 0) {
            errors.push(`Line ${i + 1}: category ${l.vatCategory} must have a 0% rate.`);
        }
    });
    // Arithmetic consistency.
    const t = inv.totals;
    if (t) {
        const expectedIncl = round2(t.taxExclusiveAmount + t.taxTotalAmount);
        if (round2(t.taxInclusiveAmount) !== expectedIncl) {
            errors.push(`Totals do not reconcile: exclusive ${t.taxExclusiveAmount} + tax ${t.taxTotalAmount} != inclusive ${t.taxInclusiveAmount}.`);
        }
        const sumLines = round2(((_e = inv.lines) !== null && _e !== void 0 ? _e : []).reduce((s, l) => s + l.lineNetAmount, 0));
        if (round2(t.lineExtensionAmount) !== sumLines) {
            errors.push(`Line extension total ${t.lineExtensionAmount} != sum of line nets ${sumLines}.`);
        }
    }
    else {
        errors.push('Missing document totals (BG-22).');
    }
    // Full tax invoice (>= R5000) requires recipient details.
    if (((_f = t === null || t === void 0 ? void 0 : t.taxInclusiveAmount) !== null && _f !== void 0 ? _f : 0) >= 5000 && !((_g = inv.buyer) === null || _g === void 0 ? void 0 : _g.vatNumber)) {
        warnings.push('Amount >= R5000: a full tax invoice should carry the recipient VAT number (BT-48).');
    }
    return { valid: errors.length === 0, errors, warnings };
}
exports.validateEInvoice = validateEInvoice;
